//Contract Section start
export const error_select_one_brand = 'Only select one brand in contract';
export const error_select_one_property = 'You can only select one right holder/partner in contract';
export const error_select_country = 'Please select country.';
export const error_already_select_country = 'Country already selected.';
export const error_lense_should_100 = 'Total weight of all the lenses should be 100';
export const error_enter_comment = 'Please enter comment';
export const error_comment_should_500 = 'Comment should not be more than 500 characters.';
export const error_comment_should_text_number = 'Please use only text / numbers for comment';
export const error_enter_dimension_weight = 'Please enter dimension weight';
export const error_enter_dimension_should_0_100 =
  'Dimension weight should be greater than 0 and smaller than and equal to 100.';
export const error_enter_dimension_should_100 = 'Total of dimension weight should be equal to 100.';
export const error_enter_oe = 'Please enter oe importance level';
export const error_oe_should_0_100 =
  'OE importance level should be greater than 0 and smaller than and equal to 100.';
export const error_enter_property = 'Please enter right holder/partner importance level';
export const error_property_should_0_100 =
  'Right Holder/Partner importance level should be greater than 0 and smaller than and equal to 100.';
export const error_enter_objective_weight = 'Please enter objective weight';
export const error_objective_weight_should_0_100 =
  'Objective_weight should be greater than 0 and smaller than and equal to 100.';
export const error_enter_country_objective_weight = 'Please enter country objective weight';
export const error_country_objective_weight_0_100 =
  'Country objective weight should be greater than 0 and smaller than and equal to 100.';
export const error_objective_should_100 = 'Total of objective weight should be equal to 100.';
export const error_country_objective_should_100 =
  'Total of country objective weight should be equal to 100.';
export const error_select_cost_of_activation = 'Please select cost of activation.';
export const error_select_exclusivity = 'Please select exclusivity.';
export const error_select_exclusivity_duration = 'Please select exclusivity duration.';
export const error_select_sequence = 'Please select sequence.';
export const error_select_duration_unit = 'Please select unit of measurement Duration.';
export const error_enter_quantity_field_duration = 'Please enter quantity field duration.';
export const error_enter_quantity_field_sequence = 'Please enter quantity field sequence.';
export const error_select_channel = 'Please select channel.';
export const error_select_rights_location = 'Please select location.';
export const error_select_rights = 'Please select right.';
export const error_enter_comment_field = 'Please enter comment field.';
export const error_select_hospitality = 'Please select hospitality.';
export const error_select_meet_and_greet = 'Please select meet and greet.';
export const error_select_parking_ticket_category = 'Please select parking ticket category.';
export const error_select_special_items = 'Please select special items.';
export const error_select_visitor_ticket_category = 'Please select ticket category.';
export const error_select_visitor_type = 'Please select visitor_type.';
export const error_select_work_pass_category = 'Please select work pass category.';
export const error_duration_amount = 'Please enter duration amount';
export const error_duration_amount_length_valdation =
  'Amount value should not be more than 10 digits';
export const error_select_per = 'Please select per';
export const error_enter_quantity = 'Please enter quantity';
export const error_enter_quantity_length = 'Quantity should not be more than 4 characters.';
export const error_enter_quantity_integer = 'Quantity should be integer value.';
//Contract Section end

//----------------------------Add Brand & Lenses Accordion Component---------------------------------//

export const error_group_select_brand = 'Please select brand.';
export const error_group_provide_group_name = 'Please provide group name.';
export const error_group_text_number_validation =
  'Please use only text / numbers for Benchmark Group’s name';
export const error_group_text_number_100_validation =
  'Group name should not be more than 100 characters.';
export const error_group_same_group_validation =
  'Group name can not be same as previous created group';
export const error_group_property_type_select = 'Please select property type.';
export const error_group_property_select = 'Please select property.';
export const error_lense_sum_validation = 'The sum of the lenses must be equal to 100.';
export const error_dimension_sum_validation = 'The sum of the dimensions must be equal to 100.';
export const error_objective_sum_validation = 'The sum of the objectives must be equal to 100.';
export const error_score_sum_validation = 'Score total must be 100';
export const error_form_profile_logo_select = 'Please select brand logo.';
export const error_form_brand_name = 'Please provide a brand name.';
export const error_form_brand_name_validation =
  'Brand name should not be more than 100 characters.';
export const error_form_industry_select = 'Please select industry.';
export const error_form_country_select = 'Please select country.';
export const error_form_currency_select = 'Please select currency.';
export const error_form_strategic_choice_select = 'Please select strategic choice.';
export const error_form_strategic_choice_country_select = 'Please select strategic choice country.';
export const error_form_governance_group_select = 'Please select governance group.';
export const error_form_primary_email = 'Please enter primary email.';
export const error_form_primary_email_validation = 'Please enter valid primary email.';
export const error_form_secondory_email_validation = 'Please enter valid secondary email.';
export const error_form_instagram_url_validation = 'Please enter valid instagram url.';
export const error_form_facebook_url_validation = 'Please enter valid facebook url.';
export const error_form_twitter_url_validation = 'Please enter valid twitter url.';
export const error_form_youtube_url_validation = 'Please enter valid youtube url.';
export const error_form_linkdin_url_validation = 'Please enter valid linkedIn url.';
export const error_form_website_url_validation = 'Please enter valid website url.';
export const error_form_url_length_validation = 'You can not enter more than 500 character in url';
export const error_form_image_validation = 'Please select image only , Accepted images are ';
export const error_nick_name = 'Please provide name';
export const error_nick_name_validation = 'Please use only text / numbers for name';
export const error_nick_name_length_validation = 'Name should not be more than 100 characters.';
export const error_nick_name_already_validation = 'This name already be in use';
export const error_nick_name_select = 'Please select nick name';
export const error_provide_description = 'Please provide description';
export const error_description_validation = 'Please use only text / numbers for in description';
export const error_description_length_validation =
  'You can not enter more than 500 character in description';
export const error_email_length_validation = 'Email should not be more than 100 characters.';
export const error_form_wikipedia_url_validation = 'Please enter valid Wikipedia url.';

//-----------------------Add Brand & Lenses Accordion Component End -----------------//

//--------------------------------Add Property Start ------------------------------------//

export const error_property_logo_select = 'Please select property logo.';
export const error_cluster_select = 'Please select cluster.';
export const error_property_type_select = 'Please select property type.';
export const error_property_category_select = 'Please select category.';
export const error_property_team_select = 'Please select team.';
export const error_first_name = 'Please provide property’s first name';
export const error_first_name_length_validation = 'Name should not be more than 100 characters.';
export const error_last_name = 'Please provide property’s last name';
export const error_nationality_select = 'Please select nationality';
export const error_team_name = 'Please provide team name';
export const error_height_weight_validation =
  'Please enter max 3 digit numeric number / Please enter max 5 digit number with 2 digit decimal';
export const error_maturity_select = 'Please select maturity .';
export const error_team_level_select = 'Please select team level .';
export const error_team_club_select = 'Please select team club';
export const error_team_select = 'Please select team';
export const error_person_name = 'Person’s Name is required';
export const error_rights_category_select = 'This data is required, please select at least one';
export const error_rights_amount = 'Please enter amount.';
export const error_select_one_rightholder = 'You can only select one right holder';

//--------------------------------Add Property End ------------------------------------//

//--------------------------------Add Activation Start ------------------------------------//
export const error_activation_logo_select = 'Please select activation logo.';

//--------------------------------Add Activation End ------------------------------------//

//--------------------------------DBS Start ------------------------------------//

export const error_upload_file_select = 'Please upload file.';
export const error_source_type_select = 'Please select source type.';
export const error_source_name = 'Please enter source name.';
export const error_classification_select = 'Please select classification.';
export const error_client_review_select = 'Please select client review.';
export const error_file_accepted = 'Only this files are accepted ';
export const error_hq_country_select = 'Please select hq country ';

//--------------------------------DBS End ------------------------------------//

//--------------------------------Header Component------------------------------------//

export const error_same_property_select = 'You can not add same property for compare';
export const error_comment = 'Please enter comment.';
export const error_tag_select = 'Please enter comment.';

//--------------------------------Header Component End------------------------------------//

// -------------------------------User Info (All User) Start-------------------------------------//

export const error_user_logo_select = 'Please Select User Logo.';
export const error_user_workmail_validation = 'Please enter a valid work email.';
export const error_user_workmail_enter = 'Please enter the work email.';
export const error_workmail_length_validation = 'Workmail should not be Grater than 100.';
export const error_user_firstname = 'Please provide Your First Name.';
export const error_user_firstname_text_number_validation =
  'Please use only text / numbers for First name.';
export const error_user_firstname_length_validation = 'First name should not be grater than 100.';
export const error_user_lastname = 'Please provide Your Last Name.';
export const error_user_lastname_text_number_validation =
  'Please use only text / numbers for Last name.';
export const error_user_lastname_length_validation = 'Last name should not be grater than 100.';
export const error_user_contact_number = 'Please provide your contact number.';
export const error_user_contact_number_length_validation =
  'Contact number should not be greater than 20.';
export const error_user_nationality_select = 'Please select nationality.';
export const error_user_currency_select = 'Please select currency.';
export const error_user_address1 = 'Please provide your address.';
export const error_user_address1_length_validation =
  'Address length should not be greater than 200.';
export const error_user_address2 = 'Please provide your address.';
export const error_user_address2_length_validation =
  'Address length should not be greater than 200.';
export const error_user_role_select = 'Please select user role .';
export const error_user_brand_select = 'Please select brand.';
export const error_user_category_select = 'Please select category.';
export const error_user_country_select = 'Please select country.';
export const error_user_property_select = 'Please select property.';
export const error_user_name_for_role = 'Please provide a name for role';
export const error_user_role_name_limit = 'Role should not be more than 40 characters';
export const error_user_role_name_format = 'Role format is invalid';
export const error_user_role_description = 'Please enter valid description.';
export const error_user_role_description_limit =
  'Description should not be more than 500 characters.';
export const error_user_role_at_least_one_permission =
  'Please select at least one permission for every role.';
export const error_select_user_type = 'Please select user type.';

// -------------------------------User Info (All User) End-------------------------------------//
